import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useUser } from '../../contexts/UserContext';
import Blocks from '../blocks/Blocks';
import StyledButton from '../buttons/StyledButton';
// import PropTypes from 'prop-types';
import PageMeta from '../partials/PageMeta';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/pages/page.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function ProPage({ page = null }) {
    const user = useUser();
    const route = useUrlGenerator();
    const { type = null, title = null, blocks = null } = page || {};
    return (
        <div className={classNames([styles.container, { [styles[type]]: type !== null }])}>
            <PageMeta page={page} />
            <Title size="large">{title}</Title>
            <div className={styles.top}>
                {user !== null ? (
                    <>
                        <Text className={styles.text}>
                            <FormattedMessage
                                defaultMessage="You are already connected."
                                description="Message label"
                            />
                        </Text>
                        <StyledButton
                            className={styles.button}
                            size="large"
                            href={route('pro.home')}
                        >
                            <FormattedMessage
                                defaultMessage="Go to my pro corner"
                                description="Button label"
                            />
                        </StyledButton>
                    </>
                ) : (
                    <>
                        <Text className={styles.text}>
                            <FormattedMessage defaultMessage="Click here to login or create a new account." />
                        </Text>
                        <div className={styles.buttons}>
                            <StyledButton
                                className={styles.button}
                                size="large"
                                href={route('login')}
                            >
                                <FormattedMessage
                                    defaultMessage="Login"
                                    description="Button label"
                                />
                            </StyledButton>
                            <StyledButton
                                className={styles.button}
                                size="large"
                                href={route('signup')}
                            >
                                <FormattedMessage
                                    defaultMessage="Create account"
                                    description="Button label"
                                />
                            </StyledButton>
                        </div>
                    </>
                )}
            </div>
            <div className={styles.spacer} />
            {blocks !== null && blocks.length > 0 ? (
                <Blocks className={styles.blocks} blocks={blocks} />
            ) : null}
        </div>
    );
}

ProPage.propTypes = propTypes;

export default ProPage;
